import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, CardBody } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import BusinessService from "./Businesses.service.js";
import AuthService from "../Authentication/auth.service.js";
import Alerts from "../../components/Alerts/alerts.js";
import { getFileUrl } from "../../utils/fileUtils";
import { SensitiveImage, SensitiveText } from "../../context/SensitiveInfoContext";
import ImagePreviewModal from "../../components/Modals/ImagePreviewModal";

const TabGenralConfig = ({business_id}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewTitle, setPreviewTitle] = useState("");
  
  const [data, setData] = useState({
    full_name: '',
    gender: '',
    dob: '',
    phone: '',
    email: '',
    medical_assistant_id: '',
    ic_ocr_number: '',
    ic_image: '',
    IC_Verification: '',
    ic_verification_reason: '',
    password: '',
    status: '',
    image: '',
    face_left: '',
    face_right: '',
  });

  //get data
  useEffect(() => {
    const fetchData = async () => {
        setLoading(true);
        BusinessService.GetSinglePatient(business_id).then((response) => {
            setLoading(false);
            if (response.data.message === "Unauthorized") {
                AuthService.logout();
                navigate("/login");
                window.location.reload();
            } else {
                if (response.data.status == true) {
                    const row = response.data.data.data;
                    setData({
                      full_name: row.full_name,
                      gender: row.gender,
                      dob: row.dob,
                      phone: row.phone,
                      email: row.email,
                      medical_assistant_id: row.medical_assistant_id || '',
                      ic_ocr_number: row.ic_ocr_number || '',
                      ic_image: row.ic_image || '',
                      IC_Verification: row.IC_Verification || 'pending',
                      ic_verification_reason: row.ic_verification_reason || '',
                      password: row.password,
                      status: row.status,
                      image: row.image || '',
                      face_left: row.face_left || '',
                      face_right: row.face_right || '',
                      });
                    
                  }
                  else {
                    Alerts.swalErrorAlert(t("Something went wrong, Please try again."));
                  }
            }
        }, (error) => {
            setLoading(false);
            const errContent = (error.response && error.response.data) || error.message || error.toString();
            if (errContent) {
                Alerts.swalErrorAlert(errContent);
            } else {
                Alerts.swalErrorAlert(t("Server Error, Please try again later."));
            }
        });
    };
    fetchData();
  }, [business_id]);


  return (
    
    <Fragment>
      <Row>
        <Col md="12">
          <Card className="main-card">
            <LoadingOverlay tag="div" active={loading}
              styles={{ overlay: (base) => ({ ...base }) }}
              spinner={<DNALoader />}>
              <CardBody>
                <table className="table table-striped table-bordered nowrap" >
                  <tbody>
                    <tr style={{ width: '100%' }}>
                      <th style={{ width: '50%' }}>{t('Full Name')}</th>
                      <td style={{ width: '50%' }}>{data.full_name}</td>
                    </tr>
                    <tr>
                      <th>{t('Gender')}</th>
                      <td>{data.gender}</td>
                    </tr>
                    <tr>
                      <th>{t('Date of birth')}</th>
                      <td>{data.dob}</td>
                    </tr>
                    
                    <tr>
                      <th>{t('Phone')}</th>
                      <td>{data.phone}</td>
                    </tr>
                    <tr>
                      <th>{t('Email')}</th>
                      <td>{data.email}</td>
                    </tr>
                    <tr>
                      <th>{t('NRIC No')}</th>
                      <td><SensitiveText value={data.medical_assistant_id} /></td>
                    </tr>
                    <tr>
                      <th>{t('OCR NRIC')}</th>
                      <td><SensitiveText value={data.ic_ocr_number} /></td>
                    </tr>
                    <tr>
                      <th>{t('IC Verification')}</th>
                      <td>{data.IC_Verification || "pending"}</td>
                    </tr>
                    {data.ic_verification_reason ? (
                      <tr>
                        <th>{t('IC Reason')}</th>
                        <td>{data.ic_verification_reason}</td>
                      </tr>
                    ) : null}
                    <tr>
                      <th>{t('IC Image')}</th>
                      <td>
                        {data.ic_image ? (
                          <SensitiveImage
                            src={getFileUrl(data.ic_image)}
                            alt="IC"
                            style={{ width: "80px", height: "50px", objectFit: "cover", cursor: "pointer" }}
                            onClick={() => {
                              setSelectedImage(getFileUrl(data.ic_image));
                              setPreviewTitle(t("IC Image"));
                              setModalOpen(true);
                            }}
                          />
                        ) : (
                          <span>{t('No Image')}</span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>{t('Status')}</th>
                      <td>{data.status}</td>
                    </tr>

                    <tr>
                      <th>{t('Front Face Image')}</th>
                      <td>
                        {data.image ? (
                          <SensitiveImage
                            src={getFileUrl(data.image)}
                            alt={data.full_name}
                            style={{ width: "50px", height: "50px", borderRadius: "100%", cursor: "pointer" }}
                            onClick={() => {
                              setSelectedImage(getFileUrl(data.image));
                              setPreviewTitle(t("Front Face Image"));
                              setModalOpen(true);
                            }}
                          />
                        ) : (
                          <span>{t('No Image')}</span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>{t('Left Face Image')}</th>
                      <td>
                        {data.face_left ? (
                          <SensitiveImage
                            src={getFileUrl(data.face_left)}
                            alt="Left face"
                            style={{ width: "50px", height: "50px", borderRadius: "100%", cursor: "pointer" }}
                            onClick={() => {
                              setSelectedImage(getFileUrl(data.face_left));
                              setPreviewTitle(t("Left Face Image"));
                              setModalOpen(true);
                            }}
                          />
                        ) : (
                          <span>{t('No Image')}</span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>{t('Right Face Image')}</th>
                      <td>
                        {data.face_right ? (
                          <SensitiveImage
                            src={getFileUrl(data.face_right)}
                            alt="Right face"
                            style={{ width: "50px", height: "50px", borderRadius: "100%", cursor: "pointer" }}
                            onClick={() => {
                              setSelectedImage(getFileUrl(data.face_right));
                              setPreviewTitle(t("Right Face Image"));
                              setModalOpen(true);
                            }}
                          />
                        ) : (
                          <span>{t('No Image')}</span>
                        )}
                      </td>
                    </tr>

                  </tbody>
                </table>
              </CardBody>
            </LoadingOverlay>

          </Card>
        </Col>
      </Row>

      <ImagePreviewModal
        show={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setSelectedImage(null);
        }}
        src={selectedImage}
        title={previewTitle}
      />

    </Fragment >

  );

};
export default TabGenralConfig; 